import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { createRef, useEffect, useState } from "react";
import { FabrixIcon, translate } from "../../common";
import { useIcon } from "../../hooks";
import UserProfileInfo, { UserProfileRef } from "./user-profile-info";

export interface UserProfileDialogProps {
    open: boolean;
    onClose: () => void;
}

export function UserProfileDialog(props: UserProfileDialogProps) {
   const icon = useIcon();
    const [_open, setOpen] = useState<boolean>();
    const ref = createRef<UserProfileRef>();


    useEffect(() => {
        setOpen(props.open)

    }, [props.open])

    const handleClose = () => {
        setOpen(false)
        props.onClose();
    }


    const handleSave  = async () => {
        if (ref.current) {
            await ref.current.save();
        }
        handleClose();
    }
    
    const renderFooter = () => {
        return (
            <div>
                <Button id="dialog-save" label={translate("SAVE")}  icon={icon(FabrixIcon.dialogSave)} onClick={handleSave} className="p-button-outlined fbx-button-outlined" />
                <Button id="dialog-cancel" label={translate("CANCEL")} icon={icon(FabrixIcon.dialogCancel)} onClick={handleClose} className="p-button-outlined fbx-button-outlined p-button-secondary" />
            </div>
        )
    }

    return (
         <Dialog id="fields-dialog" header={translate("USER_PROFILE")} visible={_open} style={{ width: '800px', height: '450px' }}
            footer={renderFooter()} onHide={handleClose}>
           <UserProfileInfo mode="user" showSave={false} ref={ref} showImage={false} style={{ width: '100%', height: '100%' }} />
        </Dialog >
    )
}